import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  acceptedPolicies: false,
};

export const policiesSlice = createSlice({
  name: "policies",
  initialState,
  reducers: {
    hasAcceptedPoliciesAgreement: (state, action) => {
      state.acceptedPolicies = action.payload;
    },
  },
});

export const { hasAcceptedPoliciesAgreement } = policiesSlice.actions;

export default policiesSlice.reducer;
